import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { EnvironmentProvider } from './context/EnvironmentContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { AppShell } from './components/Layout/AppShell';
import { LoginPage } from './pages/auth/LoginPage';
import { RegisterPage } from './pages/auth/RegisterPage';
import { Verify2faPage } from './pages/auth/Verify2faPage';
import { HomeRedirect } from './pages/dashboard/HomeRedirect';
import { KybWizardPage } from './pages/kyb/KybWizardPage';
import { PayoutsPage } from './pages/payouts/PayoutsPage';
import { DeveloperPage } from './pages/developer/DeveloperPage';
import { DisputesPage } from './pages/disputes/DisputesPage';
import { TeamPage } from './pages/team/TeamPage';
import { SecurityPage } from './pages/settings/SecurityPage';
import { SettlementGuard } from './components/Layout/SettlementGuard';
import { SettlementWalletPage } from './pages/settlement/SettlementWalletPage';
import { TerminalsPage } from './pages/terminals/TerminalsPage';

export default function App() {
  return (
    <BrowserRouter>
      <EnvironmentProvider>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/verify-2fa" element={<Verify2faPage />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<AppShell />}>
                <Route index element={<HomeRedirect />} />
                <Route path="kyb" element={<KybWizardPage />} />
                <Route path="settlement" element={<SettlementWalletPage />} />
                <Route path="payouts" element={<PayoutsPage />} />
                <Route path="developer" element={<DeveloperPage />} />
                <Route
                  path="terminals"
                  element={
                    <SettlementGuard>
                      <TerminalsPage />
                    </SettlementGuard>
                  }
                />
                <Route path="disputes" element={<DisputesPage />} />
                <Route path="team" element={<TeamPage />} />
                <Route path="security" element={<SecurityPage />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </EnvironmentProvider>
    </BrowserRouter>
  );
}
